<template>
    <div class="row justify-content-center">
        <transition name="fade" mode="out-in">
            <AppPlaceholder class="col-xl-8" v-if="!productType" key="no-product-type"/>
            <div v-else class="col-xl-8" key="product-type">
                <div class="row">
                    <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
                        <div class="pl-3">
                            <h4>
                                {{ isNew
                                ? 'New product type'
                                : productType.name }}
                            </h4>
                            <p class="mb-0 text-muted" v-if="!isNew">
                                <small>Created on {{ productType.created_at | date }}</small>
                            </p>
                        </div>
                        <div>
                            <button class="btn btn-primary mr-2"
                                    :disabled="loading"
                                    @click="save">
                                Save
                            </button>
                            <button class="btn btn-outline-secondary"
                                    :disabled="loading"
                                    @click="saveAndClose">
                                Save & close
                            </button>
                            <b-dropdown variant="link"
                                        no-caret
                                        right
                                        v-if="!isNew">
                                <template v-slot:button-content>
                                    <i class="material-icons">more_vert</i>
                                </template>
                                <b-dropdown-item :disabled="loading"
                                                 @click="destroy">
                                    Delete
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <AppInput label="Name"
                                      :value="productType.name"
                                      field="name"
                                      :errors="errors"
                                      @change="updateProductTypeProps({ name: $event })"
                                      class="col-md-6"/>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import NotificationService from '../../services/notification.service';
import AppInput from '../form/AppInput';
import AppPlaceholder from '../form/AppPlaceholder';
import Errors from '../../utils/errors';
import { formatDate } from '../../filters/date.filter';

export default {
  components: {
    AppInput,
    AppPlaceholder,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      canClose: false,
    };
  },

  filters: {
    date: formatDate,
  },
  computed: {
    ...mapGetters({
      productType: 'productTypes/productType',
    }),
    isNew() {
      return this.$route.params.id === 'new';
    },
  },
  mounted() {
    this.initProductType();
  },
  watch: {
    '$route.params.id'() {
      this.initProductType();
    },
  },
  methods: {
    initProductType() {
      return this.isNew
        ? this.$store.dispatch('productTypes/newProductType')
        : this.getProductType();
    },
    getProductType() {
      this.$store.dispatch('productTypes/getProductType', this.$route.params.id);
    },
    updateProductTypeProps(props) {
      this.$store.dispatch('productTypes/updateProductTypeProps', props);
    },
    saveAndClose() {
      this.save()
        .then(() => {
          if (this.canClose) {
            this.$router.push({ name: 'product-types' });
          }
        });
    },
    save() {
      this.loading = true;
      this.errors.clear();
      return this.$store.dispatch(this.isNew ? 'productTypes/createProductType' : 'productTypes/updateProductType')
        .then((res) => {
          this.canClose = true;
          if (this.isNew) {
            this.$router.push({
              name: 'product-type',
              params: { id: res.product_type_id },
            });
          }
          NotificationService.success(res.message);
        })
        .catch((err) => {
          this.canClose = false;
          this.errors.set(err.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    destroy() {
      this.$bvModal.msgBoxConfirm('Delete product type?', {
        okTitle: 'Delete',
        okVariant: 'danger',
      })
        .then((value) => {
          if (value) {
            this.$store.dispatch('productTypes/deleteProductType')
              .then((res) => {
                NotificationService.success(res.message);
                this.$router.push({ name: 'product-types' });
              });
          }
        });
    },
  },
};
</script>
